import React, {FC} from "react";
import {IFormItem} from "../Types";
import {Form, Input,Switch} from "antd";

export const __FormSwitch: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
            valuePropName={props.valuePropName}
        >
            <Switch
            	checkedChildren={props.checkedChildren||"开启"}
                unCheckedChildren={props.unCheckedChildren||"关闭"}
                disabled={props.disable}
            />
        </Form.Item>
    )
}